import { gql } from "@apollo/client";

export const GET_ALL_PERIODOS = gql`
    query GetAllPeriodos {
        periodos {
            idPeriodo
            mes
            ano
            activo
            fechaDesde
            fechaHasta
        }
    }
`;

export const adaptPeriodosArray = (data) => {
  if (!data || !data.periodos) return [];

    return data.periodos.map((periodo) => ({
        idPeriodo: periodo.idPeriodo,
        mes: periodo.mes,
        anio: periodo.ano,
        activo: periodo.activo,
        fechaDesde: periodo.fechaDesde,
        fechaHasta: periodo.fechaHasta,
    }));
}
